import { Button } from "@/components/ui/button";

export function FooterCta({
  enabled,
  loading,
  onContact,
}: {
  enabled: boolean;
  loading?: boolean;
  onContact?: () => void;
}) {
  return (
    <div className="lg:mt-8 w-screen relative left-1/2 -translate-x-1/2">
      <div className="relative lg:bg-[url(@/assets/images/bg-cta.png)] bg-[url(@/assets/images/bg-cta-mobile.png)] bg-cover bg-center bg-no-repeat overflow-hidden h-[360px] md:min-h-[344px] md:h-auto flex items-center">
        <div className="relative z-10 w-full max-w-[1120px] px-5 min-[1120px]:px-0 mx-auto px-5 py-10 lg:px-0 md:py-12 flex flex-col gap-6 md:gap-4">
          <div className="flex flex-col gap-3 md:gap-3 text-center md:text-left ">
            <span className=" hidden md:block text-[36px] leading-[44px] tracking-[-0.0278em] md:text-[44px] md:leading-[52px] md:tracking-[-0.03em] font-normal text-black whitespace-pre-line">
              선택하신 조합으로 PwC{"\n"}
              컨설턴트와 시작해 보세요
            </span>
            <span className="md:hidden text-[36px] leading-[44px] tracking-[-0.0278em] md:text-[44px] md:leading-[52px] md:tracking-[-0.03em] font-normal text-black whitespace-pre-line">
              선택하신 조합으로{"\n"}PwC 컨설턴트와 시작{"\n"}해 보세요
            </span>
            <span className="text-xl leading-6 lg:leading-7 font-normal text-[#000000] hidden md:block">
              전담 매니저가 24시간 내 연락드려 도입 일정,
              <br />
              견적을 함께 설계합니다.
            </span>
            <span className="text-xl leading-6 lg:leading-7 font-normal text-[#000000] md:hidden">
              전담 매니저가 24시간 내 연락드려 도입 일정, 견적을 함께 설계합니다.
            </span>
          </div>
          <div className="w-full md:w-[322px]">
            <Button
              type="button"
              disabled={!enabled || !!loading}
              onClick={onContact}
              className="w-full h-12 rounded-[4px] text-base font-bold text-black whitespace-nowrap"
            >
              PwC에 컨택하기
            </Button>
          </div>
        </div>
      </div>
    </div>
  );
}
